import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; 
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, CommonModule, TranslocoModule],
  templateUrl: './session-expired-dialog.component.html'
})
export class SessionExpiredDialogComponent implements OnInit, OnDestroy {
  private timerSubscription!: Subscription;
  timeLeft: number = 120; // 2 minutos
  isLogoutNotification: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SessionExpiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Recibe title, message y isLogoutNotification
  ) {
    this.isLogoutNotification = data?.isLogoutNotification || false;
  }

  ngOnInit(): void {
    // Solo iniciar countdown si no es una notificación de logout
    if (!this.isLogoutNotification) {
      this.startCountdown();
    }
  }

  private startCountdown(): void {
    this.timerSubscription = interval(1000)
      .pipe(takeWhile(() => this.timeLeft > 0))
      .subscribe({
        next: () => {
          this.timeLeft--;
          if (this.timeLeft === 0) {
            this.dialogRef.close(false); // Cierre automático por falta de respuesta
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}